<script lang="ts">
  import { page } from '$app/stores'
  import { t } from '$lib/translations'

  export let statusCode = 500
  export let statusText = 'Internal Server Error'
  export let hideDescription = false
  export let description = $t('common.default_error_description')
</script>

<div class="w-full flex justify-center items-center p-9">
  <div class="max-w-xl flex flex-col justify-center items-center text-center gap-5">
    <h1 class="text-9xl font-bold">Oops!</h1>
    <div class="flex flex-col items-center gap-1">
      <h2 class="text-3xl font-semibold">{$page.status || statusCode} - {$page.error?.message || statusText}</h2>
      {#if !hideDescription}
        <p>{description}</p>
      {/if}
    </div>

    <a
      href="/"
      class="bg-cs-orange px-9 py-3 rounded-md text-white font-semibold hover:bg-cs-light-orange uppercase"
    >
      {$t('common.go_to_homepage')}
    </a>
  </div>
</div>
